import { memo, useMemo,useEffect } from 'react';
import { useStore } from '@/store';
import styles from './index.module.scss';
import { getAssetUrl } from '@/utils/common';
import { Carousel } from 'antd';
import { useQueryLandmark } from '@/services/hooks';
import { HomePlaceInfo } from '@/store/types';
import { useSpring, animated } from '@react-spring/web';
import { driveDigitalHumanBySpeak, driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';
import { HomeText } from '../../config';
import { getScenicDataInsights, getScenicDataInsightsText } from '@/services/get';
import {Image} from '@shuwen/wenlv-web-activity-library';

const HomePlaceDetail = () => {
  const homePlaceId = useStore((state) => state.homePlaceId);
  // const setHomePlaceId = useStore((state) => state.setHomePlaceId);
  const { data } =  useQueryLandmark();
  const homePlaceDetail = useMemo(() => {
    return data?.find((item: HomePlaceInfo) => item.entity_id === homePlaceId);
  }, [data, homePlaceId]);
  // 语音控制
  useEffect(()=>{
    if(!data) return;
    // console.log('homePlaceDetail',homePlaceDetail);
    if(homePlaceDetail){
      // const xihuInsight = getScenicDataInsights(homePlaceDetail.biz_info?.scenic_data_insights);
      // // console.log('xihuInsight',xihuInsight);
      // if(xihuInsight){
      //   driveDigitalHumanBySpeak(xihuInsight);
      // }
      driveDigitalHumanByText(`好的，已为您介绍${homePlaceDetail.name}，请看详情页。`);

    }else if(homePlaceId){
      console.warn('未找到相关地标',homePlaceId);
      driveDigitalHumanByText('未找到相关地标，你可以选择其他地标');
    }
  },[data,homePlaceDetail]);
 
  // 防止语音多次播报
  useEffect(()=>{
    if(!homePlaceId){
      driveDigitalHumanByText('“文学西湖”从百亿数据中提炼出一万余首西湖诗文，串联唐宋至近现代千余文学家笔下的200余地标，构建全球最完整的西湖文学图鉴。');
    }
  },[])



  const springs = useSpring({
    scale:homePlaceDetail?1:0.5,
    opacity: homePlaceDetail?1:0,
    config: {
      // tension: 300,
      // friction: 20
    }
  });

  const pointdetails = useMemo(()=>{
    // return homePlaceDetail?.biz_info?.scenic.data_insights
    // ?.splice(0,3)
    return homePlaceDetail?.ext_neighborList
    ?.filter((item: any)=>item.vertex.label === 'creative_work' && item.edge.tags?.includes('展示地标'))
    ?.splice(0,3)
  },[homePlaceDetail])

  const relatedPeople = useMemo(()=>{
    return homePlaceDetail?.ext_neighborList
    ?.filter((item: any)=>item.vertex.label === 'ppl' && item.edge.tags?.includes('展示地标'))
    ?.splice(0,5)
  },[homePlaceDetail])

  // console.log(homePlaceDetail);
  
  return homePlaceDetail && (
    <animated.div
      className={styles.overlay}
      style={springs}
    >
      <div style={{position:'relative', width: '100%'}}>
        <div className={styles.content}>
          {(
            <div className={styles.imageContainer}>
              <Carousel autoplay>
                {
                  homePlaceDetail.ext_materialList?.length&&homePlaceDetail.ext_materialList?.length>0?
                  homePlaceDetail.ext_materialList?.splice(0,8)?.map((item) => (
                    <div key={item.entity_id} className={styles.contentStyle}>
                      <Image
                        src={item.url}
                        alt={item.url}
                      />
                    </div>
                  )):(
                    <div className={styles.contentStyle}>
                      <Image
                        src={homePlaceDetail.image}
                        alt={homePlaceDetail.image}
                      />
                    </div>
                  )
            
                }
              </Carousel>
            </div>
          )}
          <div className={styles.container_detail}>
            <div className={styles.details_title}>
              <div className={styles.title}>
                <h2>{homePlaceDetail?.name}</h2>
                {/* <span>100+位名人去过</span> */}
              </div>
              {/* <p className={styles.address}>
                <span>地址：</span>
                <span>{homePlaceDetail?.struct_address.address || homePlaceDetail?.struct_address.province + homePlaceDetail?.struct_address.city}</span>
              </p> */}
            </div>
          
            {/* <p className={styles.pointdetails}>文化符号延伸</p>
            <div className={styles.tags}>
              {
                homePlaceDetail?.type?.map((item: any) => (
                  <p>{item}</p>
                ))
              }
            </div> */}
            <p className={styles.pointdetails}>
              <img src={getAssetUrl('images/landmark/literatureimg.svg')} alt="" />
            </p>
            <div className={styles.tags}>
              {
                pointdetails?.map((item: any, index: number) => (
                  <p key={index}>{item.vertex.name}</p>
                ))
              }
            </div>
            <p className={styles.pointdetails}>
              <img src={getAssetUrl('images/landmark/pointposition.svg')} alt="" />
            </p>
            <p className={styles.description}>{getScenicDataInsightsText(homePlaceDetail?.biz_info?.scenic_data_insights)}</p>
          </div>
        </div>
        <div className={styles.character}>
          {/* <p className={styles.line}>
            <img src={getAssetUrl('images/landmark/line.svg')} alt="" />
          </p> */}
          <div className={styles.character_all}>
          <p className={styles.title}>相关人物</p>
          <div className={styles.character_con}>
            {
              relatedPeople?.map((item: any,index: number) => (
                <div className={styles.items} key={`relatedPeople${index}`}>
                  <Image src={item.vertex.image ? item.vertex.image : getAssetUrl('images/landmark/man.png')} alt="" />
                  <p>{item.vertex.name}</p>
                </div>
              ))
            }
          </div>
          </div>
        </div>
      </div>

    </animated.div>
  );
};

export default memo(HomePlaceDetail); 